import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const CONTENT_TYPE_DELETED = gql`
  subscription contentTypeDeleted {
    contentTypeDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
